<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {},
  computed: {},
  created() {
    // if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.$wxConfig();
    // }
  },
  mounted() {},
  watch: {},
};
</script>
<style>
html{
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none;  /*webkit浏览器*/
    -ms-user-select: none;   /*IE10*/
    -khtml-user-select: none; /*早期浏览器*/
    user-select: none;
}
#app {
  width: 100%;
  min-height: 100vh;
}
* {
  margin: 0;
  padding: 0;
}
.flex {
  display: flex;
}
.fw-w {
  flex-wrap: wrap;
}
.fw-nw {
  flex-wrap: nowrap;
}
.fd-r {
  flex-direction: row;
}
.fd-c {
  flex-direction: column;
}
.fd-rr {
  flex-direction: row-reverse;
}
.ai-c {
  align-items: center;
}
.ai-fd {
  align-items: flex-end;
}
.ai-fs {
  align-items: flex-start;
}
.ai-bl {
  align-items: baseline;
}
.jc-c {
  justify-content: center;
}
.jc-sb {
  justify-content: space-between;
}
.jc-sa {
  justify-content: space-around;
}
.jc-fd {
  justify-content: flex-end;
}
.jc-fs {
  justify-content: flex-start;
}
.line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
:-moz-placeholder {
  color: #666666 !important;
  opacity: 1;
  font-weight: 400;
}

::-moz-placeholder {
  color: #666666 !important;
  opacity: 1;
  font-weight: 400;
}

input:-ms-input-placeholder {
  color: #666666 !important;
  opacity: 1;
  font-weight: 400;
}

input::-webkit-input-placeholder {
  color: #666666 !important;
  opacity: 1;
  font-weight: 400;
}

input::-moz-input-placeholder {
  color: #666666 !important;
  opacity: 1;
  font-weight: 400;
}
textarea::-webkit-input-placeholder {
  color: #666666;
}

</style>
